import { Mutation, Query } from 'core';
import gql from 'graphql-tag';

const CREATE_SHIPMENT_QUOTE = gql`
  mutation CreateShipmentQuote($input: CreateShipmentQuoteInput!) {
    createShipmentQuote(input: $input) {
      id
    }
  }
`;

export class CreateShipmentQuoteMutation extends Mutation {
  static conf = {
    GQL: CREATE_SHIPMENT_QUOTE,
    inputName: ['input'],
    resultPath: 'createShipmentQuote',
  };
}

// incoterm
// downPayment
// fee
// feeDiscount
// manufacturingTime
// bufferTime
const SHIPMENT_QUOTE_FRAGMENT = gql`
  fragment shipmentQuoteFields2 on ShipmentQuote {
    id
    totalCost
    createdAt
    bufferTime
    notes
    validUntil
    shippingQuote {
      id
    }
    address {
      id
    }
    productQuotes {
      id
      finalCost
      currency
      createdAt
      validUntil
      for {
        id
        quantity
        build {
          id
          process {
            id
            name
            parentProcess {
              id
              name
            }
          }
          material {
            id
            name
            parentMaterial {
              id
              name
            }
          }
          values {
            of {
              id
              valueType
              name
              unit
              nilLabel
              prefix
            }
            valueFloat
            valueInt
            valueBool
            valueString
          }
          file {
            id
            filename
            conversionGltfjson {
              id
              status
            }
          }
        }
      }
      from {
        id
        jobSpec {
          id
          quantity
          build {
            id
            process {
              id
              name
              parentProcess {
                id
                name
              }
            }
            material {
              id
              name
              parentMaterial {
                id
                name
              }
            }
            values {
              of {
                id
                valueType
                name
                unit
                nilLabel
                prefix
              }
              valueFloat
              valueInt
              valueBool
              valueString
            }
            # file {
            #   id
            #   filename
            #   conversionGltfjson {
            #     id
            #     status
            #   }
            # }
          }
        }
      }
    }
    miscItems {
      id
      name
      cost
      discount
      currency
    }
    customerSpace {
      id
      content {
        id
        slug
        title
      }
      spaceType
    }
  }
`;

const CLONE_SHIPMENT_QUOTE_QUERY = gql`
  ${SHIPMENT_QUOTE_FRAGMENT}
  query ShipmentQuoteQuery($id: ID!) {
    shipmentQuote(id: $id) {
      ...shipmentQuoteFields2
      productQuotes {
        cost
        supplier {
          id
          companyName
        }
      }
      shippingQuote {
        currency
        cost
        deliveryTime
        discount
        provider
      }
      takeRate
      incoterm
      manufacturingTime
    }
  }
`;

export class CloneShipmentQuoteQuery extends Query {
  static conf = {
    GQL: CLONE_SHIPMENT_QUOTE_QUERY,
    resultPath: 'shipmentQuote',
  };
}

const SHIPMENT_QUOTES_CONNECTION_QUERY = gql`
  ${SHIPMENT_QUOTE_FRAGMENT}
  query ShipmentQuotes(
    $first: Int
    $offset: Int
    $sortField: String
    $sortOrder: SortOrder
    $filters: [FilterInput!]
    $spaceId: ID
  ) {
    shipmentQuotes(
      first: $first
      offset: $offset
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
      spaceId: $spaceId
    ) {
      total
      nodes {
        ...shipmentQuoteFields2
      }
    }
  }
`;

export class ShipmentQuotesConnectionQuery extends Query {
  static conf = {
    GQL: SHIPMENT_QUOTES_CONNECTION_QUERY,
    resultPath: 'shipmentQuotes',
    varNames: [
      'first',
      'offset',
      'sortField',
      'sortOrder',
      'filters',
      'spaceId',
    ],
  };
}

const INTERMEDIATOR_SHIPMENT_QUOTES_CONNECTION_QUERY = gql`
  ${SHIPMENT_QUOTE_FRAGMENT}
  query IntermediatorShipmentQuotes(
    $first: Int
    $offset: Int
    $sortField: String
    $sortOrder: SortOrder
    $filters: [FilterInput!]
    $spaceId: ID
  ) {
    shipmentQuotes(
      first: $first
      offset: $offset
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
      spaceId: $spaceId
    ) {
      total
      nodes {
        ...shipmentQuoteFields2
      }
    }
  }
`;

export class IntermediatorShipmentQuotesConnectionQuery extends Query {
  static conf = {
    GQL: INTERMEDIATOR_SHIPMENT_QUOTES_CONNECTION_QUERY,
    resultPath: 'shipmentQuotes',
    varNames: [
      'first',
      'offset',
      'sortField',
      'sortOrder',
      'filters',
      'spaceId',
    ],
  };
}
